import { InputBase, styled } from '@mui/material';
import { IMaskInput } from 'react-imask';

export const HBInputBaseRootStyle = styled(IMaskInput)(({ theme }) => ({}));
export const HBInputBaseSimpleRootStyle = styled(InputBase)(({ theme }) => ({}));
